import React, { useState, useEffect } from 'react';
import './styles/Signup.css';
import { PaystackButton } from 'react-paystack';
import { supabase } from './supabaseClient';
import { useNavigate, Link } from 'react-router-dom';
import { Home } from 'lucide-react';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [hasPaid, setHasPaid] = useState(false);
  const [isFirstFive, setIsFirstFive] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const publicKey = 'pk_live_05c29819512301b1db7ab3bd62684e530eeae50f';
  const amount = isFirstFive ? 40000 : 60000; // in kobo => R400 or R600
  const currency = 'ZAR';

  useEffect(() => {
    const checkUsers = async () => {
      const { data: users } = await supabase.from('users').select('id');
      if (users && users.length < 5) {
        setIsFirstFive(true);
      }
    };
    checkUsers();
  }, []);

  const handleSuccess = () => {
    setHasPaid(true);
  };

  const handleSignup = async () => {
    if (!hasPaid) {
      setError('Please complete payment before signing up.');
      return;
    }

    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    });

    if (error) {
      setError(error.message);
    } else {
      navigate('/dashboard');
    }
  };

  const componentProps = {
    email,
    amount,
    metadata: {
      email,
    },
    publicKey,
    text: `Pay R${amount / 100} to Sign Up`,
    onSuccess: handleSuccess,
    onClose: () => alert('Payment closed'),
    currency,
  };

  return (
    <div className="signup-container">
      <Link to="/home" className="home-icon">
        <Home size={26} />
      </Link>
      <div className="signup-box">
        <h2>Sign Up to Smart Trading Pro EA</h2>
        {error && <p className="error">{error}</p>}
        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {!hasPaid ? (
          <PaystackButton className="pay-btn" {...componentProps} />
        ) : (
          <button className="signup-btn" onClick={handleSignup}>
            Complete Signup
          </button>
        )}

        <p className="note">
          {isFirstFive
            ? '🎉 You’re one of the first 5 users! Signup for R400'
            : 'Signup costs R600'}
        </p>

        <p className="login-link">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;